import axios from "@/utils/request";
export const loginApi=(
    data:{
        userName:string,
        password:string,
        code:string,
        randomStr:string
    }
)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/login",
        method:"POST",
        data
    })
}
export const upApi=(data:any)=>{
    return axios({
        path:"/users",
        method:"POST",
        data
    })
}

export const resetPassWord=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/resetPassWord",
        method:"POST",
        data
    })
}

export const checkUserName=(username:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/checkUserName?username=" + username,
    })
}

export const resetUserName=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/resetUserName",
        method:"POST",
        data
    })
}
